import { useState, useEffect } from 'react';
import { getCachedImageOrFetch } from './imageCache';

export const useCachedImage = (url) => {
  const [cachedUrl, setCachedUrl] = useState(url);

  useEffect(() => {
    async function fetchImage() {
      if (url) {
        const newUrl = await getCachedImageOrFetch(url);
        setCachedUrl(newUrl);
      }
    }
    fetchImage();
  }, [url]);

  return cachedUrl;
};
